import { Contract } from '@ethersproject/contracts'
import { abi as IUniswapV2PairABI } from '@uniswap/v2-core/build/IUniswapV2Pair.json'
import { CONVEYOR_V2_ROUTER_ABI } from 'constants/abis/conveyor-v2'
import { useMemo } from 'react'

import { ROUTER_ADDRESS } from '../data/sunset/types'
import { getContract } from '../utils/contract'
import { useActiveWeb3React } from './index'

// returns null on errors
function useContract(
  address: string | undefined,
  ABI: any,
  withSignerIfPossible = true
): Contract | null {
  const { library, account } = useActiveWeb3React()

  return useMemo(() => {
    if (!address || !ABI || !library) return null
    try {
      return getContract(
        address,
        ABI,
        library,
        withSignerIfPossible && account ? account : undefined
      )
    } catch (error) {
      console.error('Failed to get contract', error)
      return null
    }
  }, [address, ABI, library, withSignerIfPossible, account])
}

export function useV1FactoryContract(): Contract | null {
  return null
}

export function useConveyorV2RouterContract(): Contract | null {
  // const { chainId } = useActiveWeb3React()
  // const environment = useEnvironment()

  const abi = CONVEYOR_V2_ROUTER_ABI
  const address = ROUTER_ADDRESS

  return useContract(address, abi)
}

export function useFeeContract(
  _tokenAddress?: string,
  _withSignerIfPossible?: boolean
): Contract | null {
  return null
}

export function useWETHContract(_withSignerIfPossible?: boolean): Contract | null {
  return null
}

export function useArgentWalletDetectorContract(): Contract | null {
  return null
}

export function useENSRegistrarContract(_withSignerIfPossible?: boolean): Contract | null {
  return null
}

export function useENSResolverContract(
  _address: string | undefined,
  _withSignerIfPossible?: boolean
): Contract | null {
  return null
}

export function useBytes32TokenContract(
  _tokenAddress?: string,
  _withSignerIfPossible?: boolean
): Contract | null {
  return null
}

export function usePairContract(
  pairAddress?: string,
  withSignerIfPossible?: boolean
): Contract | null {
  return useContract(pairAddress, IUniswapV2PairABI, withSignerIfPossible)
}

export function useMulticallContract(): Contract | null {
  return null
}

export function useMulticall2Contract() {
  return null
}

export function useMerkleDistributorContract(): Contract | null {
  return null
}

export function useGovernanceContract(): Contract | null {
  return null
}

// export function useUniContract(): Contract | null {
//   const { chainId } = useActiveWeb3React()
//   return useContract(chainId ? UNI[chainId].address : undefined, UNI_ABI, true)
// }

export function useStakingContract(
  _stakingAddress?: string,
  _withSignerIfPossible?: boolean
): Contract | null {
  return null
}

export function useSocksController(): Contract | null {
  return null
}
